import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

import { isExtendedPerformanceRange } from '@home/components/home-performance-chart/home-performance-chart.util';
import { PerformanceFilterRangeValue, PerformanceFilterTab } from '@shared/models/Home';

@Component({
  selector: 'app-home-perf-chart-settings-modal',
  standalone: false,
  templateUrl: './home-perf-chart-settings-modal.component.html',
  styleUrl: './home-perf-chart-settings-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomePerfChartSettingsModalComponent implements OnInit {
  private modalController = inject(ModalController);
  private fb = inject(FormBuilder);

  @Input() kind: '3a' | '3b' | 'kid' | 'grow';
  @Input() showBenchmark = false;
  @Input() showPortfolioChanges = false;
  @Input() modalPerformanceFilters: PerformanceFilterTab[];
  @Input() currentRange: PerformanceFilterRangeValue;
  @Input() hasPortfolioUpdatesFlag: boolean;

  info = {
    timeframe: false,
    portfolioChanges: false,
    benchmark: false
  };

  get selectedRangeControl(): AbstractControl {
    return this.form.get('selectedRange') as AbstractControl;
  }

  get showPortfolioChangesControl(): AbstractControl {
    return this.form.get('showPortfolioChanges') as AbstractControl;
  }

  get benchmarkVisibilityControl(): AbstractControl {
    return this.form.get('benchmarkVisibility') as AbstractControl;
  }

  form: FormGroup = this.fb.group({
    selectedRange: [''],
    showPortfolioChanges: [false],
    benchmarkVisibility: [this.showBenchmark, Validators.required]
  });

  ngOnInit() {
    this.selectedRangeControl.setValue(this.currentRange);
    this.showPortfolioChangesControl.setValue(this.showPortfolioChanges);
    this.benchmarkVisibilityControl.setValue(this.showBenchmark);
    this.benchmarkVisibilityControl.updateValueAndValidity();
  }

  onFilterChange(event) {
    this.selectedRangeControl.setValue(event);
  }

  onShowPortfolioChanges() {
    this.showPortfolioChangesControl.setValue(!this.showPortfolioChangesControl.value);
  }

  onShowInfo(infoItem: 'benchmark' | 'timeframe' | 'portfolioChanges') {
    this.info[infoItem] = !this.info[infoItem];
  }

  onSubmit() {
    const selectedRange = this.selectedRangeControl.value;

    this.modalController.dismiss({
      ...(isExtendedPerformanceRange(selectedRange) && selectedRange !== this.currentRange && { selectedRange: selectedRange }),
      ...(this.showPortfolioChangesControl.value !== this.showPortfolioChanges && { showPortfolioChanges: this.showPortfolioChangesControl.value }),
      ...(this.kind !== '3a' &&
        this.benchmarkVisibilityControl.value !== this.showBenchmark && { showBenchmark: this.benchmarkVisibilityControl.value })
    });
  }

  onDismiss() {
    this.modalController.dismiss();
  }
}
